export var LOGIN = 'login';
export var LOGIN_SUCCESS = 'login.success';
export var LOGIN_FAILED = 'login.failed';
export var GET_PRIVILEGE = 'get.privilege';
export var GET_PRIVILEGE_SUCCESS = 'get.privilege.success';
export var GET_PRIVILEGE_FAILED = 'get.privilege.failed';
export var LOGOUT = 'logout';
export var LOGOUT_SUCCESS = 'logout.success';
export var LOGOUT_FAILED = 'logout.failed'; // 登录

export function loginAction(entity, privileges) {
  return {
    type: LOGIN,
    entity: entity,
    privileges: privileges
  };
} // 登录成功

export function loginSuccessAction(user) {
  return {
    type: LOGIN_SUCCESS,
    payload: user
  };
} // 登录失败

export function loginFailedAction(error) {
  return {
    type: LOGIN_FAILED,
    payload: error
  };
} // 获取权限

export function getPrivilegeAction(entity, user) {
  return {
    type: GET_PRIVILEGE,
    entity: entity,
    payload: user
  };
} // 获取权限成功

export function getPrivilegeSuccessAction(user) {
  return {
    type: GET_PRIVILEGE_SUCCESS,
    payload: user
  };
} // 获取权限失败

export function getPrivilegeFailedAction(error) {
  return {
    type: GET_PRIVILEGE_FAILED,
    payload: error
  };
} // 登出

export function logoutAction() {
  return {
    type: LOGOUT
  };
} // 登出成功

export function logoutSuccessAction() {
  return {
    type: LOGOUT_SUCCESS
  };
} // 登出失败

export function logoutFailedAction(error) {
  return {
    type: LOGOUT_FAILED,
    payload: error
  };
}